module.exports = __webpack_public_path__ + "img/orange_006.68d57d1a.png";